import {
  CONTRAT_ETAT_BROUILLON,
  CONTRAT_TYPE_PRIVE,
  TERME_PAIEMENT_AVANCE,
  ANNEE,
} from '@/configuration/baux/contrat/contratConf';
import { ETAT_ENATTENTE } from '@/configuration/devisConf';

export default function genererContrat(natureContratId) {
  return {
    contratsMateriels: [],
    echeancier: [],
    intervenants: [],
    code: null,
    commentaire: null,
    loyerAnnuelHt: 0,
    loyerAnnuelTva: 0,
    tauxTva: 0,
    loyerAnnuelTtc: 0,
    societeId: null,
    agenceId: null,
    dateDebutSignature: null,
    dateFinSignature: null,
    dateDebutEcheance: null,
    dateFinEcheance: null,
    dateFinPremiereEcheance: null,
    datePreavis: null,
    quantitePeriodicite: 1,
    unitePeriodicite: ANNEE,
    termePaiement: TERME_PAIEMENT_AVANCE,
    type: CONTRAT_TYPE_PRIVE,
    reconductible: true,
    tacite: false,
    dateRenouvellement: null,
    contratInitialId: null,
    ordreRenouvellement: 0,
    loyerAnnuelHtBaseIndexation: 0,
    pourcentageIndexation: 0,
    indiceBase: 0,
    indiceLast: 0,
    signataireId: null,
    natureId: natureContratId,
    etat: CONTRAT_ETAT_BROUILLON,
    etatRenouvellement: ETAT_ENATTENTE,
    isComingFromAjoutMateriel: false,
    commission: null,
    fournisseurDemarcheurId: null,
    contrepartie: null,
    responsableBailId: null,
    estIndexe: false,
    typeIndexation: null,
    montantIndexationReference: 0,
    dateDerniereIndexation: null,
    valeurIndexationReference: 0,
    dateIndexationReference: null,
    indiceReferenceId: null,
    valeurIndexationActuel: 0,
    dateIndexationActuel: null,
  };
}
